'use strict';
var core = require('core-js');
import {Merchandise} from './model/merchandise';
import {Info} from './model/info';
import {MainContent} from './view/maincontent';
import {KaguraException} from './view/kagura-exception';

(function() {
  window.KAGURA = window.KAGURA || Object.create(null);
  function getParamaterByName(name, url) {
    if(!url) url = location.href;
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(url);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
  Object.defineProperty(KAGURA, 'status', {
    get: function() {return this._status;},
    set: function(status) {
      this._status = status;
      this[status.toLowerCase()]();
    },
    enumerable: true
  });
  KAGURA.json_request = function() {
    var merchandise = new Merchandise(KAGURA.resourceURLs.origin + KAGURA.resourceURLs.merchandise);
    var info = new Info(KAGURA.resourceURLs.origin + KAGURA.resourceURLs.info);
    Promise.all([
      merchandise.init(),
      info.init()
    ])
    .then(function(responses) {
      if('error' in KAGURA) {
        delete KAGURA.error;
      }
      /* 商品情報 */
      KAGURA.merchandise = KAGURA.merchandise || Object.create(null);
      KAGURA.merchandise.type = responses[0].pagetype;
      KAGURA.merchandise.page = KAGURA.merchandise.page || Object.create(null);
      KAGURA.merchandise.page.current = responses[0].currentPage;
      KAGURA.merchandise.page.last = responses[0].lastPage;
      KAGURA.merchandise.id = responses[0].id;
      KAGURA.merchandise.items = responses[0].items;
      /* 商品カテゴリ */
      KAGURA.merchandise.classification = responses[1].categories;
      /* 原作 */
      KAGURA.authorities = responses[1].authrities;
    })
    .catch(function(err) {
      if('merchandise' in KAGURA) {
        delete KAGURA.merchandise;
      }
      /* エラー情報 */
      KAGURA.error = KAGURA.error || Object.create(null);
      KAGURA.error.reason = err.message;
    })
    .finally(function() {
      KAGURA.status = 'RENDER';
    });
  };
  KAGURA.render = function() {
    var df = document.createDocumentFragment();
    if('merchandise' in KAGURA) {
      var mainContent = new MainContent(
        KAGURA.merchandise.type,
        KAGURA.merchandise.id,
        KAGURA.merchandise.page,
        KAGURA.merchandise.items,
        KAGURA.merchandise.classification
      );
      df.appendChild(mainContent.create());
    } else if('error' in KAGURA) {
      var kaguraException = new KaguraException(KAGURA.error.reason);
      df.appendChild(kaguraException.create());
    }
    document.getElementById('main').appendChild(df);
    /* GOOGLE ANALYTICS */
    var virtualUrl = KAGURA.getVirtualUrl();
    if(history.pushState && history.state !== undefined) {
      history.pushState(null, '『閃乱カグラ』シリーズポータルサイト', virtualUrl);
    }
    ga('send', 'pageview', virtualUrl);
    /* EVENT LISTENER */
    if('merchandise' in KAGURA) {
      var referenceNode = document.getElementById('merchandise');
      referenceNode.addEventListener('click', KAGURA.onclick, false);
    }
  };
  KAGURA.refresh = function() {
    var referenceNode = document.getElementById('merchandise');
    if(referenceNode) {
      referenceNode.removeEventListener('click', KAGURA.onclick, false);
    } else {
      referenceNode = document.getElementById('merchandise-error');
    }

    var range = document.createRange();
    range.selectNode(referenceNode);
    range.deleteContents();
    range.detach();

    KAGURA.status = 'JSON_REQUEST';
  };
  KAGURA.resourceURLs = Object.create(null);
  KAGURA.onDOMContentLoaded = function(e) {
    if(process.env.NODE_ENV === 'production') {
      KAGURA.resourceURLs.origin = 'https://assets-kagura.marv.jp';
    } else {
      KAGURA.resourceURLs.origin = 'https://assets-kagura-stg.marv.jp';
    }
    var paramaters = Object.create(null);
    paramaters.type = getParamaterByName('type');
    paramaters.id = getParamaterByName('id');
    paramaters.page = getParamaterByName('p');
    KAGURA.resourceURLs.merchandise = KAGURA.createJSONRequestPathname(paramaters);
    KAGURA.resourceURLs.info = '/items/info.json';
    KAGURA.status = 'JSON_REQUEST';
  };
  KAGURA.onclick = function(e) {
    e.preventDefault();
    if(e.target.nodeType !== Node.ELEMENT_NODE) {
      return;
    }
    if(e.target.nodeName.toLowerCase() === 'a') {
      if(e.target.href.indexOf(location.host) === -1) {
        window.open(e.target.href, 'newTab');
      } else {
        const paramaters = Object.create(null);
        paramaters.type = getParamaterByName('type', e.target.href);
        paramaters.id = getParamaterByName('id', e.target.href);
        paramaters.page = getParamaterByName('p', e.target.href);
        KAGURA.resourceURLs.merchandise = KAGURA.createJSONRequestPathname(paramaters);
        KAGURA.status = 'REFRESH';
      }
    } else if(e.target.nodeName.toLowerCase() === 'img') {
      if(e.target.className.indexOf('image--merchandise-thumbnail') === -1) return;
      const parent = e.target.parentNode;
      if(parent.nodeName.toLowerCase() !== 'a') return;
      if(parent.hasAttribute('href')) {
        if(parent.href.indexOf(location.host) === -1) {
          window.open(parent.href, 'newTab');
        }
      }
    }
  };
  KAGURA.onPopState = function(e) {
    var paramaters = Object.create(null);
    paramaters.type = getParamaterByName('type') === 'error' ? '' : getParamaterByName('type');
    paramaters.id = getParamaterByName('id');
    paramaters.page = getParamaterByName('p');
    KAGURA.resourceURLs.merchandise = KAGURA.createJSONRequestPathname(paramaters);
    KAGURA.status = 'REFRESH';
  };
  KAGURA.createJSONRequestPathname = function(params) {
    var url = '/items';
    if(params.type.length === 0 && params.page.length > 0) {
      url += '/index_' + params.page + '.json';
    } else if(params.type.length === 0 && params.page.length === 0) {
      url += '/index.json';
    } else {
      if(params.id.length > 0 && params.page.length > 0) {
        url += '/' + params.type;
        url += '/' + params.id;
        url += '_' + params.page + '.json';
      } else if(params.id.length > 0 && params.page.length === 0) {
        url += '/' + params.type;
        url += '/' + params.id + '.json';
      } else if(params.id.length === 0 && params.page.length > 0) {
        url += '/' + params.type;
        url += '_' + params.page + '.json';
      } else {
        url += '/' + params.type + '.json';
      }
    }
    return url;
  };
  KAGURA.getVirtualUrl = function() {
    var virtualUrl = location.origin + location.pathname;
    var regex = new RegExp('[\\?&]');
    if('error' in KAGURA) {
      var result = regex.exec(virtualUrl);
      virtualUrl += result === null ? '?type=' : '&type=';
      virtualUrl += 'error';
    } else {
      if(KAGURA.merchandise.type !== 'index') {
        const result = regex.exec(virtualUrl);
        virtualUrl += result === null ? '?type=' : '&type=';
        virtualUrl += KAGURA.merchandise.type;
      }
      if(KAGURA.merchandise.id) {
        const result = regex.exec(virtualUrl);
        virtualUrl += result === null ? '?id=' : '&id=';
        virtualUrl += KAGURA.merchandise.id;
      }
      if(KAGURA.merchandise.page.current > 1) {
        const result = regex.exec(virtualUrl);
        virtualUrl += result === null ? '?p=' : '&p=';
        virtualUrl += KAGURA.merchandise.page.current;
      }
    }
    return virtualUrl;
  };
  document.addEventListener('DOMContentLoaded', KAGURA.onDOMContentLoaded, false);
  window.addEventListener('popstate', KAGURA.onPopState, false);
}());